export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-regular.450beda71fb8564202a0fe714305d1f3.woff2";